<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pXigY0/tc-custom/9783987446894.jpg?1704424707391" alt="This image is the cover for the book The Edge Of The Knife and three more stories, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Edge Of The Knife and three more stories, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>This is a great collection of action short stories by H. Beam Piper from "The Golden Age of Science Fiction". Featured here: "The Edge Of The Knife", "Day Of The Moron", "The Answer", and "Omnilingual".</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. Beam Piper
      </h2>
      
      <p class="authorDescription body article">Henry Beam Piper (March 23, 1904 – c.  November 6, 1964) was an American science fiction writer. He wrote many short stories and several novels. He is best known for his extensive Terro-Human Future History series of stories and a shorter series of "Paratime" alternate history tales.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f77d20e